import {request} from "../../../utils/apiUtils";
import {URL_API} from "../../../url.config";

let FeeItemController = {

    create: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/fee-item/create`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    list: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/fee-item/list`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    edit: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/fee-item/edit`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    detail: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/fee-item/detail/${id}`,
            method: 'GET'
        }, callback)
    },
    delete: (id, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/fee-item/delete/${id}`,
            method: 'GET'
        }, callback)
    }
}

export default FeeItemController
